import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import Accordeon from 'components/no-auth/utils/Accordeon';

import { articlePropType } from 'helpers/customPropTypes';

import Video from './Video';

const FAQ = (props) => {
    const getFaqList = (paragraphs) => {
        return paragraphs.map((key) => {
            return <Accordeon title={key.title} text={key.text} key={key.title} />;
        });
    };

    const data = props.data;

    return (
        <section className="section-faq no-spinner" id="landing-faq">
            <div className="box-1280">
                {data.sections.length > 0 && (
                    <div className="inner-content">
                        <div className="lead-text max-620">
                            <h2 className="title1">{props.faqTitle}</h2>
                        </div>
                        <Video url={data.youtubeVideoUrl} extra={props?.extra} countryMenu={props?.countryMenu} isRequest={props.isRequest} />
                        <div className="accordeon-block">
                            <ol id="accordeon" className="accordeon-block maincopy">
                                {getFaqList(data.sections)}
                            </ol>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

FAQ.propTypes = {
    data: PropTypes.shape({
        linkTitle: PropTypes.string.isRequired,
        youtubeVideoUrl: PropTypes.string.isRequired,
        sections: PropTypes.arrayOf(articlePropType),
    }),
};
const mapStateToProps = (state) => {
    return {
        faqTitle: state.messages.pageMessages.faqTitle,
        extra: state.extra,
    };
};

export default connect(mapStateToProps)(FAQ);
